// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"521":"component---src-pages-dev-js","678":"component---src-pages-index-js","683":"component---src-pages-imprint-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"521":"84febecb560eb6d8d438","678":"8e6ef4585b107f07e961","683":"d1f8500907b6bc77848f","883":"9fa9c720238bd299995e"}[chunkId] + ".js";
};